import { BillShareVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import CrossLinkRow, { BookingCodeLink } from './CrossLinkRow';
import { formatShare } from './participantTotals';

interface ParticipantShareRowProps
  extends React.HTMLAttributes<HTMLDivElement> {
  share: BillShareVm;
  bookingCode: string;
  onOpenInstallments: () => void;
}

/** Udział uczestnika w wartości rezerwacji wraz z wyjściem do rat i wpłat. */
const ParticipantShareRow = ({
  share,
  bookingCode,
  onOpenInstallments,
  ...props
}: ParticipantShareRowProps) => (
  <CrossLinkRow
    actionLabel="Raty i wpłaty →"
    onAction={onOpenInstallments}
    {...props}
  >
    Udział w rezerwacji{' '}
    <BookingCodeLink bookingCode={bookingCode} onClick={onOpenInstallments} /> ·{' '}
    <span className="whitespace-nowrap">{formatShare(share)}</span>
  </CrossLinkRow>
);

export default ParticipantShareRow;
